/**
 * 单一状态树
 * vuex 操作顺序：state.js -> mutations-type.js -> mutations.js -> getters.js
 */

const state = {
  // csv配置文件生成导航数组
  menuArr: [],
  // 当前选中导航
  currentMenu: {},
  // 当前位置
  currentPosition: '',
  // 当前查询条件
  queryCondition: {},
  // 查询条件文字描述
  conditionDesc: '',
  mkeyDescription: {},
  // 报表请求路径
  reportBaseUrl: ''
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js